module.exports = __webpack_public_path__ + "static/media/smsNotif.f8e186a7.svg";